import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { MISSIONS_COUNTER } from '../../screens/Missions/constants';
import SPIN_PHASE from '../../api/GameInterface/helpers/spinPhases';

/** @typedef {{ spinPhase: string, gameId?: string|number, amount?: number }} SpinEvent */
var toKey = function toKey(v) {
  return v == null ? '' : String(v);
};
var isGameMatch = function isGameMatch(gameId, missionGameId) {
  if (missionGameId == null) return false;
  var g = toKey(gameId);
  return Array.isArray(missionGameId) ? missionGameId.map(toKey).includes(g) : g === toKey(missionGameId);
};
var safeDiv = function safeDiv(num, den) {
  return den > 0 ? num / den : 0;
};
var clamp100 = function clamp100(v) {
  return v > 100 ? 100 : v < 0 ? 0 : v;
};

/**
 * @param {'WAGE'|'WIN'} phase
 * @param {'count'|'amount'} by
 * @param {boolean} requireGame
 */
var createHandler = function createHandler(_ref) {
  var phase = _ref.phase,
    by = _ref.by,
    _ref$requireGame = _ref.requireGame,
    requireGame = _ref$requireGame === void 0 ? false : _ref$requireGame;
  return (
    /**
     * @param {SpinEvent} event
     * @param {number} counterGoal
     * @param {number} percentage
     * @param {string|number|Array<string|number>} [missionGameId]
     */
    function (event, counterGoal, percentage, missionGameId) {
      var _event$amount;
      if ((event === null || event === void 0 ? void 0 : event.spinPhase) !== SPIN_PHASE[phase]) return percentage;
      if (requireGame && !isGameMatch(event === null || event === void 0 ? void 0 : event.gameId, missionGameId)) return percentage;
      var delta = by === 'count' ? safeDiv(100, counterGoal) : safeDiv(Math.max(0, (_event$amount = event === null || event === void 0 ? void 0 : event.amount) !== null && _event$amount !== void 0 ? _event$amount : 0) * 100, counterGoal);
      return clamp100(percentage + delta);
    }
  );
};
var handlerMissionProgress = Object.freeze(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MISSIONS_COUNTER.SPIN_X_TIMES, createHandler({
  phase: 'WAGE',
  by: 'count'
})), MISSIONS_COUNTER.SPIN_X_TIMES_Y_GAMES, createHandler({
  phase: 'WAGE',
  by: 'count',
  requireGame: true
})), MISSIONS_COUNTER.WIN_X_TIMES, createHandler({
  phase: 'WIN',
  by: 'count'
})), MISSIONS_COUNTER.WIN_X_TIMES_Y_GAMES, createHandler({
  phase: 'WIN',
  by: 'count',
  requireGame: true
})), MISSIONS_COUNTER.WIN_X_AMOUNT, createHandler({
  phase: 'WIN',
  by: 'amount'
})), MISSIONS_COUNTER.WIN_X_AMOUNT_Y_GAMES, createHandler({
  phase: 'WIN',
  by: 'amount',
  requireGame: true
})), MISSIONS_COUNTER.WAGE_X_AMOUNT, createHandler({
  phase: 'WAGE',
  by: 'amount'
})), MISSIONS_COUNTER.WAGE_X_AMOUNT_Y_GAMES, createHandler({
  phase: 'WAGE',
  by: 'amount',
  requireGame: true
})));
export default handlerMissionProgress;